import styled from 'styled-components';
import { gray5, gray8 } from '../globals/colors';
import { font } from '../globals/fonts';

export var LabeledValue_Root = styled.dl.withConfig({ displayName: "LabeledValuestyle__LabeledValue_Root", componentId: "sc-11dio9b-0" })(["font-family:", ";font-size:20px;margin:0;line-height:1;"],
font.medium);





export var LabeledValue_Label = styled.dt.withConfig({ displayName: "LabeledValuestyle__LabeledValue_Label", componentId: "sc-11dio9b-1" })(["color:", ";font-size:.9em;margin-bottom:.25em;"],
gray5);




export var LabeledValue_Value = styled.dd.withConfig({ displayName: "LabeledValuestyle__LabeledValue_Value", componentId: "sc-11dio9b-2" })(["color:", ";margin:0;word-wrap:break-word;"],
gray8);
//# sourceMappingURL=LabeledValue.style.js.map